export const initialProperties = [
  {
    id: "1",
    lat: 41.1579,
    lng: -8.6291,
    image:
      "https://images.unsplash.com/photo-1568605114967-8130f3a36994?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    tipo: "interested",
    notas:
      "Beautiful 3-bedroom apartment in the heart of Porto with a view of the Douro river.",
    precoTotal: 250000,
    area: 120,
    precoM2: 2083.33,
    anoConstrucao: 1998,
    estadoGeral: "Razoável",
    varanda: "Sim",
    elevador: "Sim",
    nomeAgente: "João Silva",
    contactoAgente: "+351 912 345 678",
  },
  {
    id: "2",
    lat: 41.1496,
    lng: -8.6109,
    image:
      "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    tipo: "notInterested",
    notas:
      "Cozy 2-bedroom house with a small garden, perfect for a small family.",
    precoTotal: 180000,
    area: 90,
    precoM2: 2000,
    anoConstrucao: 2005,
    estadoGeral: "Novo",
    varanda: "Não",
    elevador: "Não",
    nomeAgente: "Maria Santos",
    contactoAgente: "+351 923 456 789",
  },
  {
    id: "3",
    lat: 41.1677,
    lng: -8.6674,
    image:
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1471&q=80",
    tipo: "visited",
    notas:
      "Luxurious 4-bedroom villa with a swimming pool and ocean view in Foz do Douro.",
    precoTotal: 350000,
    area: 200,
    precoM2: 1750,
    anoConstrucao: 2010,
    estadoGeral: "Novo",
    varanda: "Sim",
    elevador: "Não",
    nomeAgente: "António Ferreira",
    contactoAgente: "+351 934 567 890",
  },
  {
    id: "4",
    lat: 41.1489,
    lng: -8.6107,
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    tipo: "interested",
    notas: "Modern 2-bedroom apartment with river views, recently renovated.",
    precoTotal: 220000,
    area: 85,
    precoM2: 2588.24,
    anoConstrucao: 2015,
    estadoGeral: "Novo",
    varanda: "Sim",
    elevador: "Sim",
    nomeAgente: "Sofia Oliveira",
    contactoAgente: "+351 916 789 012",
  },
  {
    id: "5",
    lat: 41.1601,
    lng: -8.6286,
    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    tipo: "notInterested",
    notas:
      "Spacious 3-bedroom house with a large backyard, needs some renovation.",
    precoTotal: 280000,
    area: 150,
    precoM2: 1866.67,
    anoConstrucao: 1995,
    estadoGeral: "Razoável",
    varanda: "Não",
    elevador: "Não",
    nomeAgente: "Pedro Costa",
    contactoAgente: "+351 927 345 678",
  },
  {
    id: "6",
    lat: 41.1558,
    lng: -8.6253,
    image:
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    tipo: "visited",
    notas:
      "Charming studio apartment in the historic center, perfect for investors.",
    precoTotal: 150000,
    area: 45,
    precoM2: 3333.33,
    anoConstrucao: 1920,
    estadoGeral: "Reconstruir",
    varanda: "Não",
    elevador: "Não",
    nomeAgente: "Ana Rodrigues",
    contactoAgente: "+351 939 876 543",
  },
  {
    id: "7",
    lat: 41.1687,
    lng: -8.6718,
    image:
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    tipo: "interested",
    notas:
      "Luxurious 4-bedroom penthouse with panoramic ocean views and a private terrace.",
    precoTotal: 550000,
    area: 180,
    precoM2: 3055.56,
    anoConstrucao: 2018,
    estadoGeral: "Novo",
    varanda: "Sim",
    elevador: "Sim",
    nomeAgente: "Miguel Santos",
    contactoAgente: "+351 918 765 432",
  },
  {
    id: "8",
    lat: 41.1511,
    lng: -8.613,
    image:
      "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80",
    tipo: "notInterested",
    notas:
      "Cozy 1-bedroom apartment near public transportation, ideal for students.",
    precoTotal: 120000,
    area: 55,
    precoM2: 2181.82,
    anoConstrucao: 2000,
    estadoGeral: "Razoável",
    varanda: "Sim",
    elevador: "Não",
    nomeAgente: "Carla Ferreira",
    contactoAgente: "+351 936 543 210",
  },
];
